<template>
  <div
    class="vz-list-item"
    :class="{ 'vz-selected': selected, 'vz-loading': isLoading }"
    @click="select"
  >
    <h3 class="vz-list-item-title">{{ title }}</h3>

    <div class="vz-list-item-thumb">
      <vz-image class="vz-list-item-thumb-img" :src="coverImage" />
      <progress-bar
        :height="8"
        :value="playedRatio"
        :indicator-color="'var(--primary-color)'"
      ></progress-bar>
    </div>

    <span
      class="vz-list-item-screenbug"
      v-if="screenBug"
      :style="{ backgroundImage: 'url(' + screenBug + ')' }"
    ></span>

    <div class="vz-list-item-fav-wrapper">
      <i
        class="vz-list-item-fav"
        v-if="showFavorite"
        :class="isFavorite ? 'fa-solid fa-bookmark' : 'fa-regular fa-bookmark'"
        @click.stop="favorite"
      >
      </i>
      <span class="tooltip">
        {{ isFavorite ? 'Remover da minha lista' : 'Adicionar à minha lista' }}
      </span>
    </div>

    <i class="ic-alert-circle vz-list-item-info" v-if="showInfo">
      <span>Ver mais</span>
    </i>

    <play-button
      class="vz-list-item-play"
      v-if="showPlay"
      :is-series="!!(info.specifics.seasons && info.specifics.seasons.length)"
      :ppc="info.access.ppc"
      :predecessorName="info.access.firstPredecessorName"
      :classroom="info?.classroom || {}"
      :content-type="info.specifics.contentType"
      @play="play"
      @rent="rent"
      @click.native.stop
    >
    </play-button>

    <span class="vz-list-item-loading">
      <i class="ic-loader vz-spin"></i>
    </span>
  </div>
</template>

<script>
import VzLazyImage from 'vsp-web-ui-lib/components/atoms/vz-lazy-image.vue';
import ProgressBar from 'vsp-web-ui-lib/components/molecules/vz-progress-bar.vue';
import TitlePlayButton from '@/components/atoms/title-play-button.vue';

export default {
  name: 'TitleListItem',
  emits: ['play', 'rent', 'fav-add', 'fav-remove', 'select'],
  components: {
    vzImage: VzLazyImage,
    playButton: TitlePlayButton,
    progressBar: ProgressBar
  },

  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    showFavorite: {
      type: Boolean,
      default: false
    },
    showPlay: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    useLandscapeCover: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    id() {
      return this.info.id || '';
    },

    title() {
      return this.info.title || '';
    },

    description() {
      return this.info?.descriptions?.short || '';
    },

    isFavorite() {
      return !!this.info.inFavorites;
    },

    playedRatio() {
      return this.info?.specifics?.playedRatio || 0;
    },

    covers() {
      return this.info?.images?.thumbs || { portrait: [], landscape: [] };
    },

    coverImage() {
      const images = this.useLandscapeCover
        ? this.covers.landscape
        : this.covers.portrait;
      return images.length ? images[0] : '';
    },

    screenBug() {
      return this.info?.images?.screenbug || '';
    },

    isLoading() {
      const { content } = this.$store.state;
      const loadingStates = ['loading', 'renting'];
      if (this.id === content.current.info.id) {
        return loadingStates.indexOf(content.current.status) !== -1;
      }
      if (this.id === content.next.info.id) {
        return loadingStates.indexOf(content.next.status) !== -1;
      }
      return false;
    }
  },

  methods: {
    select() {
      if (!this.isLoading) {
        this.$emit('select', this.info);
        if (
          this.info.specifics.contentType === 'COURSE' ||
          this.info.specifics.contentType === 'MODULE'
        ) {
          this.$store.dispatch('content/selectContent', this.info);
        }
      }
    },

    favorite() {
      if (this.isFavorite) {
        this.$emit('fav-remove', this.info);
      } else {
        this.$emit('fav-add', this.info);
      }
    },

    play() {
      this.$emit('play', this.info);
    },

    rent() {
      this.$emit('rent', this.info);
    }
  }
};
</script>





























































































































































































































































































































































































































<style theme="light-theater" scoped>
.vz-list-item {
  font-size: 0.875em;
  line-height: 1.4em;
  position: relative;
  padding: 250px 0 0;
  width: 169px;
  cursor: pointer;
  display: flex;
  flex-direction: column-reverse;
}

.vz-list-item.vz-title-list-alt-item {
  width: 246px;
  padding-top: 150px;
}

.vz-list-item.vz-small-item {
  width: 125px;
  padding-top: 188px;
}

.vz-list-item.vz-loading {
  cursor: default;
}

.vz-list-item-title {
  color: #1a1a1a;
  font-weight: 600;
  margin: 0 0 0 2px;
  padding: 0 18px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vz-related .vz-list-item-title {
  word-break: break-word;
  text-align: left;
  font-size: 0.9em;
  padding: 0;
}

.vz-list-item-description {
  font-size: 0.86em;
  margin: 4px 0 4px 2px;
  max-height: 4.5em;
  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.vz-list-item-thumb,
.vz-list-item.vz-loading:hover .vz-list-item-thumb {
  display: block;
  position: absolute;
  top: 8px;
  left: 0;
  width: 100%;
  height: 237px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  overflow: hidden;
  transform: translate(0, 0);
  transition-property: width, height, transform;
  transition-duration: 0.3s;
}

.vz-list-item-thumb .vz-progress-bar {
  position: absolute;
  bottom: 0;
}

.vz-list-item-thumb:after,
.vz-list-item.vz-loading:hover .vz-list-item-thumb:after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s;
}

.vz-list-item:hover .vz-list-item-thumb {
  transform: scale(1.03);
}

.vz-list-item:hover .vz-list-item-thumb:after {
  opacity: 1;
}

.vz-selected .vz-list-item-thumb {
  border: 2px solid var(--primary-color-active);
}

.vz-list-item.vz-title-list-alt-item .vz-list-item-thumb,
.vz-list-item.vz-title-list-alt-item.vz-loading:hover .vz-list-item-thumb {
  height: 138px;
}

.vz-list-item.vz-small-item .vz-list-item-thumb,
.vz-list-item.vz-small-item.vz-loading:hover .vz-list-item-thumb {
  height: 175px;
}

.vz-list-item-thumb-img,
.vz-list-item.vz-loading:hover .vz-list-item-thumb-img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transform: translate(-50%, -50%);
  transition-property: transform;
  transition-duration: 0.3s;
}

.vz-list-item:hover .vz-list-item-thumb-img {
  transform: translate(-50%, -50%) scale(1.1);
}

.vz-list-item-fav,
.vz-list-item-play,
.vz-list-item-info,
.vz-list-item-rent,
.vz-list-item.vz-loading:hover .vz-list-item-fav,
.vz-list-item.vz-loading:hover .vz-list-item-play,
.vz-list-item.vz-loading:hover .vz-list-item-info,
.vz-list-item.vz-loading:hover .vz-list-item-rent {
  position: absolute;
  background-color: rgba(255, 0, 0, 0);
  opacity: 0;
  transition-property: opacity, color;
  transition-duration: 0.3s;
  color: #ffffff;
}

.vz-list-item-fav:hover,
.vz-list-item-play:hover,
.vz-list-item-info:hover,
.vz-list-item-rent:hover {
  color: var(--primary-color-over);
}

.vz-list-item-fav:active,
.vz-list-item-fav-active,
.vz-list-item-play:active,
.vz-list-item-info:active,
.vz-list-item-rent:active {
  color: var(--primary-color-active);
}

.vz-list-item:hover .vz-list-item-fav,
.vz-list-item:hover .vz-list-item-play,
.vz-list-item:hover .vz-list-item-info,
.vz-list-item:hover .vz-list-item-rent {
  opacity: 1;
  pointer-events: auto;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.6);
}

.vz-list-item-fav > span,
.vz-list-item-play > span,
.vz-list-item-info > span,
.vz-list-item-loading > span,
.vz-list-item-rent > span {
  display: none;
}

.vz-list-item-fav {
  top: 13px;
  right: 10px;
  font-size: 18px;
}

.vz-anonymous .vz-list-item-fav {
  display: none;
}

.vz-list-item-fav-wrapper {
  top: 0;
  right: 0;
  display: inline-block;
}

.tooltip {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 4px;
  position: absolute;
  top: 15%;
  left: 65%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s;
  margin-top: 5px;
}

.vz-list-item-fav-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.vz-list-item-play,
.vz-list-item-rent {
  top: 105px;
}

.vz-list-item-play {
  font-size: 40px;
  left: 50%;
  margin-left: -20px;
}

.vz-list-item.vz-title-list-alt-item .vz-list-item-play,
.vz-list-item.vz-title-list-alt-item .vz-list-item-rent {
  top: 55px;
}

.vz-list-item.vz-small-item .vz-list-item-play,
.vz-list-item.vz-small-item .vz-list-item-rent {
  top: 74px;
}

.vz-list-item-rent {
  font-size: 18px;
  width: 38px;
  height: 38px;
  left: 50%;
  margin-left: -18px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition-property: opacity, color, border-color;
}

.vz-list-item-rent:hover {
  border-color: var(--primary-color-over);
}

.vz-list-item-rent:active {
  border-color: var(--primary-color-active);
}

.vz-list-item-info {
  font-size: 14px;
  right: 0;
  bottom: 3px;
  color: #232323;
  text-shadow: none;
}

.vz-list-item:hover .vz-list-item-info {
  text-shadow: none;
}

.vz-list-item-screenbug {
  position: absolute;
  top: 14px;
  left: 8px;
  width: 42px;
  height: 42px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.vz-list-item-loading {
  display: block;
  position: absolute;
  top: 8px;
  left: 0;
  width: 0;
  height: 0;
  background-color: rgba(0, 0, 0, 0.25);
  opacity: 0;
  overflow: hidden;
  transition-property: opacity, width, height;
  transition-duration: 0.3s, 0s, 0s;
  transition-delay: 0s, 0.3s, 0.3s;
}

.vz-loading .vz-list-item-loading {
  width: 100%;
  height: 237px;
  opacity: 1;
  transition-delay: 0.3s, 0.3s, 0.3s;
}

.vz-small-item.vz-loading .vz-list-item-loading {
  height: 175px;
}

.vz-title-list-alt-item.vz-loading .vz-list-item-loading {
  height: 138px;
}

.vz-list-item-loading .vz-spin {
  font-size: 20px;
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0 0 -10px;
}

@media (min-width: 1441px) {
  .vz-list-item {
    width: 12.4vw;
    padding-top: 18.1vw;
  }

  .vz-list-item.vz-title-list-alt-item {
    width: 18vw;
    padding-top: 10.98vw;
  }

  .vz-list-item-thumb,
  .vz-list-item.vz-loading:hover .vz-list-item-thumb,
  .vz-loading .vz-list-item-loading {
    height: 17.35vw;
  }

  .vz-list-item.vz-title-list-alt-item .vz-list-item-thumb,
  .vz-list-item.vz-title-list-alt-item.vz-loading:hover .vz-list-item-thumb,
  .vz-title-list-alt-item.vz-loading .vz-list-item-loading {
    height: 10.1vw;
  }

  .vz-list-item-play,
  .vz-list-item-rent {
    top: calc(9.05vw - 20px);
  }

  .vz-list-item.vz-title-list-alt-item .vz-list-item-play,
  .vz-list-item.vz-title-list-alt-item .vz-list-item-rent {
    top: calc(5.49vw - 20px);
  }
}
</style>
